import { useState } from "react";
import PropTypes from "prop-types";
import SocialMediaShareButtons from "./SocialMediaShareButtons";
import CopyLinkIcon from "@/assets/svg/CopyLinkIcon";
import { appUrl, imgPath } from "@/constants/miscConstants";
import { useTranslation } from "react-i18next";

const Share = ({ image, shareValueUUID, shareURL = "property-detail" }) => {
  const { t } = useTranslation();
  const propertyUrl = `${appUrl}/${shareURL}/${shareValueUUID}`;

  const [copySuccess, setCopySuccess] = useState(false);

  const copyToClipboard = async (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 3000);
      } catch (error) {
        console.error("Failed to copy text using Clipboard API", error);
      }
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        document.execCommand("copy");
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 3000);
      } catch (error) {
        console.error("Fallback method failed to copy text", error);
      } finally {
        document.body.removeChild(textarea);
      }
    }
  };

  const handleCopyLink = async () => {
    await copyToClipboard(propertyUrl);
  };

  return (
    <div className="bg-white rounded-lg p-6 relative">
      <img
        src={image || imgPath}
        alt="Property"
        className="w-full h-[324px] object-cover rounded-xl mb-5"
      />

      <h3 className="text-lg font-normal text-secondary flex items-center justify-center mb-7">
        {t("propertyDetails.shareSocial")}
      </h3>

      <SocialMediaShareButtons propertyUrl={propertyUrl} />

      <div className="mt-8">
        <div className="w-full flex items-center justify-center">
          <button
            onClick={handleCopyLink}
            className="w-full max-w-md flex items-center justify-center gap-2 px-4 py-3 bg-white border border-gray-300 rounded-xl shadow-sm text-gray-500 text-sm font-medium hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400 overflow-hidden">
            <span className="text-gray-300 absolute z-0 opacity-20 left-10 right-10">
              {propertyUrl}
            </span>
            <CopyLinkIcon className="z-10" />
            <span className="text-[#848484] text-[18px] font-normal font-inter ml-1">
              {t("propertyDetails.copyLink")}
            </span>
          </button>
        </div>
        {copySuccess && (
          <p className="mt-2 text-sm text-secondary">
            {t("propertyDetails.linkCopied")}
          </p>
        )}
      </div>
    </div>
  );
};

const { string } = PropTypes;

Share.propTypes = {
  image: string,
  shareValueUUID: string,
  shareURL: string
};

export default Share;
